import { createFileRoute } from "@tanstack/react-router";

import { Content } from "../../../../../../../features/dashboard/pedidos/editar/$id/components/EditOrderContent";

export const Route = createFileRoute("/_private/dashboard/_base/pedidos/editar/$id/")({
  component: Content
});
